var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conter"},[_c('div',{staticClass:"top-img"}),_c('div',{staticClass:"text"}),_c('div',{staticClass:"buttom but-to",on:{"click":_vm.goto}},[_vm._v("微信登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }